import {
    responseToData,
    transferify,
    unRestangularize
} from 'shared/utils/data-service-utils';
import {ngAsync} from 'shared/utils/ng-@decorators';
import type {
    ActionResponse,
    Discardion,
    Exemplar,
    ExemplarIdentifierRequest,
    ExemplarRequest
} from 'typings/portaro.be.types';
import type {AnyObject} from 'typings/portaro.fe.types';

export default class ExemplarDataService {
    public static readonly serviceName = 'exemplarDataService';

    private static readonly EXEMPLARS_ROUTE = 'exemplars';

    /*@ngInject*/
    constructor(private Restangular: Restangular.IService) {
    }

    @ngAsync()
    @unRestangularize()
    public async query(params: AnyObject): Promise<Exemplar[]> {
        try {
            return await this.Restangular
                .all(ExemplarDataService.EXEMPLARS_ROUTE)
                .getList(params);
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async getById(exemplarId: number): Promise<Exemplar> {
        try {
            return await this.Restangular
                .one(ExemplarDataService.EXEMPLARS_ROUTE, exemplarId)
                .get();
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async save(exemplarRequest: ExemplarRequest): Promise<ActionResponse> {
        try {
            return await this.Restangular
                .all(ExemplarDataService.EXEMPLARS_ROUTE)
                .post(transferify(exemplarRequest, false));
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async delete(exemplars: Exemplar[]): Promise<ActionResponse> {
        try {
            return await this.Restangular
                .one(ExemplarDataService.EXEMPLARS_ROUTE)
                .one('delete')
                .post('', transferify({exemplars}));
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async discard(exemplarId: number, discardion: Discardion): Promise<ActionResponse> {
        try {
            return await this.Restangular
                .one(ExemplarDataService.EXEMPLARS_ROUTE, exemplarId)
                .one('discard')
                .post(null, transferify(discardion));
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async restore(exemplarId: number): Promise<ActionResponse> {
        try {
            return await this.Restangular
                .one(ExemplarDataService.EXEMPLARS_ROUTE, exemplarId)
                .one('restore')
                .post(null);
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async getSequences(property: string, currentValue: string, formModel: AnyObject): Promise<string[]> {
        try {
            return await this.Restangular
                .all(ExemplarDataService.EXEMPLARS_ROUTE)
                .one('sequences', property)
                .post(null, {
                    exemplarRequest: formModel,
                    currentValue
                });
        } catch (httpError) {
            throw responseToData(httpError);
        }
    }

    @ngAsync()
    @unRestangularize()
    public async getPrototypeOfExemplarRequestIdentifiers(exemplarRequest: ExemplarRequest): Promise<ExemplarIdentifierRequest> {
        return this.Restangular
            .one(ExemplarDataService.EXEMPLARS_ROUTE, 'identifiers')
            .post(null, transferify(exemplarRequest));
    }

}
